import { useHistory, useLocation } from "react-router-dom";

export function useQuickPayCreateDrawer() {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const isOpen = queryParams.has("quickpay_create");

  const handleOpen = () => {
    if (!queryParams.has("quickpay_create")) {
      queryParams.set("quickpay_create", "true");
    }

    history.push({
      search: queryParams.toString(),
    });
  };

  const handleClose = () => {
    if (queryParams.has("quickpay_create")) {
      queryParams.delete("quickpay_create");

      history.replace({
        search: queryParams.toString(),
      });
    }
  };

  return {
    open: isOpen,
    handleClose,
    handleOpen,
  };
}
